import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sendUserNotificationSettingChangeTelemetry } from '~src/userNotifications/telemetry/UserNotificationsTelemetry';

import { GetUserNotificationSettings, UpdateUserNotificationSettings } from '../../../app/actions/AppActionTypes';
import { Messages } from '../../../codegen/Localize';
import { ToasterService, ToastType } from '../../../ts/services/ToasterService';
import { UserNotificationSettingsLayer } from '../../models/UserNotificationSettingsLayer';
import { UserNotificationSettingsService } from '../../services/UserNotificationSettingsService';
import { GetUserNotificationSettingsAction, getUserNotificationSettingsFailedAction, getUserNotificationSettingsSucceededAction, UpdateUserNotificationSettingsAction, updateUserNotificationSettingsFailedAction, updateUserNotificationSettingsSucceededAction } from '../UserNotificationSettingsActions';

export function* handleGetUserNotificationSettingsRequest(action: GetUserNotificationSettingsAction) {
  try {
    const settings = yield call(UserNotificationSettingsService.getUserNotificationsSettings, action.layer, action.siteId);

    yield put(getUserNotificationSettingsSucceededAction({ settings: settings }));
  } catch (e) {
    yield put(getUserNotificationSettingsFailedAction());
  }
}

export function* handleUpdateUserNotificationSettingsRequest(action: UpdateUserNotificationSettingsAction) {
  try {
    const updatedSettings = action.updatedSettings;

    yield call(UserNotificationSettingsService.updateNotificationSettings, action.layer, updatedSettings, action.siteId);
    yield put(updateUserNotificationSettingsSucceededAction({ updatedSettings: updatedSettings }));
    yield call(displayUpdateSettingsToast, action.layer, true);
    yield call(sendUserNotificationSettingChangeTelemetry, action.layer, updatedSettings);
  } catch (e) {
    yield put(updateUserNotificationSettingsFailedAction());
    yield call(displayUpdateSettingsToast, action.layer, false);
  }
}

export function* rootUserNotificationSettingsSagas(): SagaIterator {
  yield takeLatest(GetUserNotificationSettings, handleGetUserNotificationSettingsRequest);
  yield takeEvery(UpdateUserNotificationSettings, handleUpdateUserNotificationSettingsRequest);
}

export function displayUpdateSettingsToast(layer: UserNotificationSettingsLayer, success: boolean)
{
  if(layer === UserNotificationSettingsLayer.User)
  {
    const toastMessage = success ? Messages.settingsUpdateSuccess() : Messages.settingsUpdateFailure();
    const toastType = success ? ToastType.Success : ToastType.Error;
    ToasterService.instance.pop({ type: toastType, text: toastMessage});
  }
}